"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const prizes = [{
  id: 1,
  title: "IPHONE",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579657/img/prize_iphone.png"
}, {
  id: 2,
  title: "MICROFON",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579657/img/prize_microphone.png"
}, {
  id: 3,
  title: "CĂȘTI",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579657/img/prize_headphones.png"
}];
export default function TombolaParticipantilor() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="tombola-participanților" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] pointer-events-none"></div>

      
    </section>;
}